/**
 * Modulo para las incidencias
 */
import IncidenciaActionsService from "./incidenciaActionsService";
import IncidenciasGridCtrl from "./incidenciasGridCtrl";
import IncidenciaDuplicadaCtrl from "./incidenciaDuplicadaDialogCtrl";
import EditIncidenciaDialogCtrl from "./editIncidenciaDialogCtrl";
import CiudadanoIncidenciaService from "./ciudadano/ciudadanoService";
import CiudadanoCtrl from "./ciudadano/ciudadanoCtrl";
import ContenedorComentariosCtrl from "./contenedor-comentarios/contenedorComentariosCtrl";
import ContendorComentariosDirective from "./contenedor-comentarios/contenedorComentariosDirectiva";
import DialogEditFechaCtrl from "./dialog-edit-fecha/dialogEditFecha.controller";
import IncidenciaRechazarCtrl from "./rechazar/incidenciaRechazarDialogCtrl";
import RelacionarIncidenciaDialogCtrl from "./relacionar/relacionarIncidenciaDialogCtrl";
import IncidenciaService from "./incidenciasService";
import ngResourceModuleName from 'angular-resource';
// noinspection ES6UnusedImports
import mentioModuleName from 'ment.io';
import ComentariosCtrl from "../comentarios/comentariosCtrl";
import ComentarioIncidenciaDataService from "../comentarios/comentarioIncidenciaService";
import ComentariosDirectiva from "../comentarios/comentariosDirectiva";
import ComentarioTareaDataService from "../comentarios/comentarioTareaService";
import TareasService from "../tareas/tareasService";
import TareaActionsService from "../tareas/tareaActionsService";
import DialogConfirmarConComentarioCtrl from "../tareas/dialogConfirmarConComentarioCtrl";
// const angular = require('angular');


const IncidenciasModule = angular
    .module('incidencias', ['app', ngResourceModuleName, 'mentio'])
    .service('Incidencia', IncidenciaService)
    .service('IncidenciaActionsService', IncidenciaActionsService)
    .controller('IncidenciasGridCtrl', IncidenciasGridCtrl)
    .controller('IncidenciaRechazarCtrl', IncidenciaRechazarCtrl)
    .controller('IncidenciaDuplicadaCtrl', IncidenciaDuplicadaCtrl)
    .controller('EditIncidenciaDialogCtrl', EditIncidenciaDialogCtrl)
    .service('CiudadanoIncidencia', CiudadanoIncidenciaService)
    .controller('CiudadanoCtrl', CiudadanoCtrl)
    .controller('ContenedorComentariosCtrl', ContenedorComentariosCtrl)
    .directive('contendorComentarios', ContendorComentariosDirective)
    .controller('DialogEditFechaCtrl', DialogEditFechaCtrl)
    .controller('RelacionarIncidenciaDialogCtrl', RelacionarIncidenciaDialogCtrl)

    .service('Tarea', TareasService)
    .service('TareaActionsService', TareaActionsService)
    .service('ComentarioTarea', ComentarioTareaDataService)
    .service('ComentarioIncidencia', ComentarioIncidenciaDataService)
    .controller('DialogConfirmarConComentarioCtrl', DialogConfirmarConComentarioCtrl)
    .directive('comentarios', ComentariosDirectiva)
    .controller('ComentariosCtrl', ComentariosCtrl)
;

export default IncidenciasModule;